import {
  getFirestore,
  doc,
  updateDoc,
  deleteDoc,
  setDoc,
  getDoc,
  collection,
  getDocs,
  where,
  query,
  limit,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { Timestamp } from "firebase/firestore";

const CLUBS = "clubs";
const USERS = "users";
const BADLEVIER = "badlevier";
const CRENEAUX = "créneaux";
const EQUIPES = "équipes";
const LICENCIES = "licenciés";
const ARTICLES = "articles";
const EVENTS = "events";
const DOCUMENTS = "documents";
const ENTRAINEMENTS = "entraînements";
const CAPITAINES = "capitaines";
const JOUEURS = "joueurs";
const PARTICIPANTS = "participants";
const ENCADRANTS = "encadrants";
const ADMINS = "admins";
const BUREAU = "bureau";
const MEMBRES = "membres";
const PRESIDENT = "président";
const VICE_PRESIDENT = "vice-président";
const TRESORIER = "trésorier";
const SECRETAIRE = "secrétaire";
//const PORTE_FEUILLE = "porte-feuille";
const MOUVEMENTS = "mouvements";
class Database {
  constructor(firebase) {
    console.log("Constructor Database");

    this.isAdmin = false;
    this.isLicencie = false;
    this.isPresident = false;
    this.isVicePresident = false;
    this.isTresorier = false;
    this.isSecretaire = false;
    this.isMemberBureau = false;
    this.isUserVerified = false;
    this.isMemberClub = false;

    this.pathPhotoURL = "/photoURL/";
    this.pathPhotoURLArticle = "/photoURLArticle/";
    this.pathPhotoURLEvent = "/photoURLEvent/";
    this.pathDocumentUrl = "/documents/";

    this.firebase = firebase;
    this.db = getFirestore(this.firebase);
    this.storage = getStorage();
    this.badlevierRef = doc(this.db, CLUBS, BADLEVIER);

  }

  fetchUserRights = async (user, isLicencie = false) => {
    if (user == null) {
      this.isAdmin = false;
      this.isPresident = false;
      this.isVicePresident = false;
      this.isTresorier = false;
      this.isSecretaire = false;
      this.isMemberBureau = false;

      this.isUserVerified = false;
      this.isLicencie = false;
      this.isMemberClub = false;

      return;
    }
    const q1 = query(doc(this.db, "clubs/badlevier"));
    const docSnap = await getDoc(q1);
    console.info("firebase : fetchUserRights - getDoc");
    if (docSnap) {
      const data = docSnap.data();
      this.isAdmin = data[ADMINS].includes(user.uid);
      this.isPresident = data[BUREAU][PRESIDENT] === user.uid;
      this.isVicePresident = data[BUREAU][VICE_PRESIDENT] === user.uid;
      this.isTresorier = data[BUREAU][TRESORIER] === user.uid;
      this.isSecretaire = data[BUREAU][SECRETAIRE] === user.uid;
      this.isMemberBureau = data[BUREAU][MEMBRES].includes(user.uid) || this.isPresident || this.isVicePresident || this.isTresorier || this.isSecretaire;
    }

    this.isUserVerified = user.emailVerified;
    this.isLicencie = isLicencie; //appartient à la liste licencie 
    this.isMemberClub = isLicencie && user.validated;  //appartient à la liste licencie et est validé

  }

  getUser = async (userUid) => {
    const q = query(collection(this.db, USERS), where("uid", "==", userUid), limit(1));
    const querySnapUser = await getDocs(q);
    console.info("firebase : getUser - getDocs => n : " + querySnapUser.docs.length);
    if (!querySnapUser.empty) {
      const document = querySnapUser.docs[0];
      return document.data();
    }
    return null;
  }

  //BUREAU

  addMembreBureau = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    if (docSnap.exists()) {
      const docBadLevier = docSnap.data();
      console.info("firebase : addMembreBureau - getDoc");
      const bureau = docBadLevier[BUREAU];
      if (!bureau[MEMBRES].includes(uid)) {
        bureau[MEMBRES].push(uid);
        await updateDoc(this.badlevierRef, { bureau: bureau });
      }
      return true;
    }
    return false;
  };
  removeMembreBureau = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    if (docSnap.exists()) {
      const docBadLevier = docSnap.data();
      console.info("firebase : removeMembreBureau - getDoc");
      const bureau = docBadLevier[BUREAU];
      bureau[MEMBRES] = bureau[MEMBRES].filter(elt => elt !== uid);
      await updateDoc(this.badlevierRef, { bureau: bureau });
      return true;
    }
    return false;
  };

  setPresident = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    const docBadLevier = docSnap.data();
    console.info("firebase : setPresident - getDoc");
    const bureau = docBadLevier[BUREAU];
    bureau[PRESIDENT] = uid;
    await updateDoc(this.badlevierRef, { bureau: bureau });
    return true;
  };
  setVicePresident = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    const docBadLevier = docSnap.data();
    console.info("firebase : setVicePresident - getDoc");
    const bureau = docBadLevier[BUREAU];
    bureau[VICE_PRESIDENT] = uid;
    await updateDoc(this.badlevierRef, { bureau: bureau });
    return true;
  };
  setTresorier = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    const docBadLevier = docSnap.data();
    console.info("firebase : setTresorier - getDoc");
    const bureau = docBadLevier[BUREAU];
    bureau[TRESORIER] = uid;
    await updateDoc(this.badlevierRef, { bureau: bureau });
    return true;
  };
  setSecretaire = async (uid) => {
    const docSnap = await getDoc(this.badlevierRef);
    const docBadLevier = docSnap.data();
    console.info("firebase : setSecretaire - getDoc");
    const bureau = docBadLevier[BUREAU];
    bureau[SECRETAIRE] = uid;
    await updateDoc(this.badlevierRef, { bureau: bureau });
    return true;
  };

  //LICENCIES
  getLicencie = async (value, key = "uid") => {
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES), where(key, "==", value), limit(1));
    const querySnapLicencie = await getDocs(q2);
    //console.info("firebase : getLicencie - getDocs =>  nb : " + querySnapLicencie.docs.lengths);
    if (!querySnapLicencie.empty) {
      const document = querySnapLicencie.docs[0];
      return document.data();
    }
    return null;
  }
  getLicencies = async () => {
    const retour = [];
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES)/*, where("lastLoginAt", "!=", null)*/);
    const querySnap = await getDocs(q2);
    console.info("firebase : getLicencie - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour.sort((a, b) =>
      a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1
    );
  }

  getLicencieByLicenceNumber = async (licenceNumber) => {
    let lic = null;
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES), where("licenceNumber", "==", licenceNumber), limit(1));
    const querySnap = await getDocs(q2);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        lic = doc.data();
      })
    }
    return lic;
  }

  getAllLicencies = async () => {
    const retour = [];
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES));
    const querySnap = await getDocs(q2);
    console.info("firebase : getLicencie - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour.sort((a, b) =>
      a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1
    );
  }

  replaceInTrainings = async (oldUid, newUid) => {
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX));
    const querySnap = await getDocs(q2);
    console.info("firebase : getCreneaux - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      await Promise.all(
        querySnap.docs.map(async currentDoc => {
          const creneau = currentDoc.data();
          const docRef = doc(
            this.db,
            CLUBS +
            "/" +
            BADLEVIER +
            "/" +
            CRENEAUX +
            "/" +
            creneau.uid
          );
          const newEnc = creneau[ENCADRANTS].map(encUid => encUid === oldUid ? newUid : encUid);
          await updateDoc(docRef, { encadrants: newEnc });
          const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX + "/" + creneau.uid + "/" + ENTRAINEMENTS));
          const querySnap2 = await getDocs(q);
          console.info("firebase : getTrainings - getDocs => nb : " + querySnap.docs.length);
          if (!querySnap2.empty) {
            await Promise.all(
              querySnap2.docs.map(async currentDoc => {
                const training = currentDoc.data();
                const docRef = doc(
                  this.db,
                  CLUBS +
                  "/" +
                  BADLEVIER +
                  "/" +
                  CRENEAUX +
                  "/" +
                  creneau.uid +
                  "/" +
                  ENTRAINEMENTS,
                  training.uid
                );
                const newEnc = training[ENCADRANTS].map(encUid => encUid === oldUid ? newUid : encUid);
                await updateDoc(docRef, { encadrants: newEnc });
                const newPart = training[PARTICIPANTS].map(partUid => partUid === oldUid ? newUid : partUid);
                await updateDoc(docRef, { participants: newPart });
              }));
          }
        }));
    }
  }

  replaceInMouvements = async (oldUid, newUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + MOUVEMENTS));
    const querySnap = await getDocs(q);
    if (!querySnap.empty) {
      await Promise.all(
        querySnap.docs.map(async doc => {
          const mouvement = doc.data();
          const docRef = doc(
            this.db,
            CLUBS +
            "/" +
            BADLEVIER +
            "/" +
            MOUVEMENTS +
            "/" +
            mouvement.uid
          );
          const newRemiseMembreBureau = mouvement.remiseMembreBureau === oldUid ? newUid : mouvement.remiseMembreBureau;
          const newLicencie = mouvement.licencie === oldUid ? newUid : mouvement.licencie;
          const newCreateur = mouvement.createur === oldUid ? newUid : mouvement.createur;
          const newDistribuePar = mouvement.distribuePar === oldUid ? newUid : mouvement.distribuePar;
          await updateDoc(docRef, {
            remiseMembreBureau: newRemiseMembreBureau,
            licencie: newLicencie,
            createur: newCreateur,
            distribuePar: newDistribuePar,
          });
        }));
    }

    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES)/*, where("lastLoginAt", "!=", null)*/);
    const querySnap2 = await getDocs(q2);
    if (!querySnap2.empty) {
      await Promise.all(
        querySnap2.docs.map(async doc => {
          const lic = doc.data();
          const q3 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES + "/" + lic.uid + "/" + MOUVEMENTS));
          const querySnap3 = await getDocs(q3);
          if (!querySnap3.empty) {
            await Promise.all(
              querySnap3.docs.map(async doc => {
                const mouvement = doc.data();
                const docRef = doc(
                  this.db,
                  CLUBS +
                  "/" +
                  BADLEVIER +
                  "/" +
                  LICENCIES +
                  "/" +
                  MOUVEMENTS +
                  "/" +
                  mouvement.uid
                );
                const newRemiseMembreBureau = mouvement.remiseMembreBureau === oldUid ? newUid : mouvement.remiseMembreBureau;
                const newLicencie = mouvement.licencie === oldUid ? newUid : mouvement.licencie;
                const newCreateur = mouvement.createur === oldUid ? newUid : mouvement.createur;
                const newDistribuePar = mouvement.distribuePar === oldUid ? newUid : mouvement.distribuePar;
                await updateDoc(docRef, {
                  remiseMembreBureau: newRemiseMembreBureau,
                  licencie: newLicencie,
                  createur: newCreateur,
                  distribuePar: newDistribuePar,
                });
              }));
          }
        }));
    }
  }

  signalLicencie = async (user) => {
    const docRef = doc(
      this.db,
      CLUBS + "/" + BADLEVIER + "/" + LICENCIES,
      user.uid
    );
    const docSnap = await getDoc(docRef);
    console.info("firebase : signalLicencie - getDoc");
    if (!docSnap.exists()) {
      const licencie = {
        uid: user.uid,
        displayName: user.displayName,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        //phoneNumber: user.phoneNumber,
        photoURL: null,
        lastLoginAt: user.lastLoginAt ? user.lastLoginAt : null,
        validated: false,
        emailVerified: user.emailVerified,
        genderMale: user.genderMale ? user.genderMale : true,
        description: "",
        simpleLevel: "NC",
        doubleLevel: "NC",
        mixteLevel: "NC",
        lastModifiedSynchro: null,
        "porte-feuille": 0,
        keyPass: false
      };
      //console.log("db : signalLicencie");
      await setDoc(docRef, licencie);

      const userExist = await this.getUser(user.uid);
      if (userExist) {
        this.removeUser(user.uid);
      }
      return true;
    }
    return false;
  };

  unsignalLicencie = async (user) => {
    const docRef = doc(
      this.db,
      USERS,
      user.uid
    );
    const docSnap = await getDoc(docRef);
    console.info("firebase : unsignalLicencie - getDoc");
    if (!docSnap.exists()) {
      if (user.lastLoginAt) {
        const userMoved = {
          uid: user.uid,
          displayName: user.displayName,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          //phoneNumber: user.phoneNumber,
          photoURL: null,
          lastLoginAt: user.lastLoginAt,
          validated: false,
          emailVerified: user.emailVerified,
          description: user.description,
          "porte-feuille": 0
        };
        //console.log("db : unsignalLicencie");
        await setDoc(docRef, userMoved);
      }

      const licencieExist = await this.getLicencie(user.uid);
      if (licencieExist) {
        this.removeLicencie(user.uid);
      }
      //await this.fetchUserRights(user, false);

      return true;
    }
    return false;
  };
  addLicencie = async (licencie) => {
    const docRef = doc(
      this.db,
      CLUBS + "/" + BADLEVIER + "/" + LICENCIES,
      licencie.uid
    );
    const docSnap = await getDoc(docRef);
    console.info("firebase : addLicencie - getDoc");
    if (!docSnap.exists()) {
      await setDoc(docRef, licencie);
      return await this.getLicencie(licencie.uid);
    }
    return false;
  };

  removeLicencie = async (uid) => {
    //console.log("db : removeLicencie");
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES, uid);
    console.info("firebase : removeLicencie - getDoc");
    await deleteDoc(docRef)
      .catch((error) => {
        console.log("Impossible de supprimer le document", error);
        return false;
      });
  };

  updateLicencie = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES, uid);
    console.info("firebase : updateLicencie - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return await this.getLicencie(uid);
  };

  addMouvement = async (obj, onUser = false) => {
    const uid = "auto-generated" + Date.now();
    let docRef;
    if (onUser) {
      docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES + "/" + obj.licencie + "/" + MOUVEMENTS, uid);
    } else {
      docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + MOUVEMENTS, uid);
    }
    const docSnap = await getDoc(docRef);
    console.info("firebase : addMouvement - getDoc");
    if (!docSnap.exists()) {
      //console.log("db : addMouvement");
      const newMouvement = {
        uid: uid,
        achatUid: obj["achatUid"] ? obj["achatUid"] : null,
        typeReglement: obj["typeReglement"],
        typeMouvement: obj["typeMouvement"],
        montant: obj["montant"],
        motif: obj["motif"],
        date: Timestamp.now(),
        createur: obj["createur"],
        status: obj["status"],
        remiseMembreBureau: obj["remiseMembreBureau"],
        remiseMembreBureauDate: obj["remiseMembreBureau"] === null ? null : Timestamp.now(),
        licencie: obj["licencie"],
        panier: obj["panier"] ? obj["panier"] : null,
        distribuePar: obj["distribuePar"] ? obj["distribuePar"] : null
      };
      await setDoc(docRef, newMouvement);
      //on n'ajoute pas tout de suite 
      //await this.updateLicencie(userUid, { "porte-feuille": licencie[PORTE_FEUILLE] + obj["montant"] });
      return true;
    }
    return false;
  };

  updateMouvement = async (uid, obj, licencieUid, onUser = false) => {
    let docRef;
    if (onUser) {
      docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + LICENCIES + "/" + licencieUid, MOUVEMENTS, uid);
    } else {
      docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + MOUVEMENTS, uid);
    }
    console.info("firebase : updateMouvement - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj)
    return true;
  };

  removeMouvement = async (uid, licencieUid, onUser = false) => {
    const docRef = doc(
      this.db,
      onUser ?
        CLUBS + "/" + BADLEVIER + "/" + LICENCIES + "/" + licencieUid + "/" + MOUVEMENTS :
        CLUBS + "/" + BADLEVIER + "/" + MOUVEMENTS,
      uid
    );
    console.info("firebase : removeMouvement - getDoc");
    await deleteDoc(docRef)
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.log("Impossible de supprimer le mouvement", error);
        return false;
      });
  };

  //USER
  /*getUserByUid = (uid) => {
    if (uid === "" || uid == null) return null;
    return this.users.find((user) => user.uid === uid);
  };*/

  addUser = async (user) => {
    const docRef = doc(this.db, USERS, user.uid);
    const docSnap = await getDoc(docRef);
    console.info("firebase : addUser - getDoc");
    if (!docSnap.exists()) {
      //console.log("db : addUser");
      await setDoc(docRef, user);
      return true;
    }
    return false;
  };

  removeUser = async (uid) => {
    //console.log("db : removeUser");
    const docRef = doc(this.db, USERS, uid);
    console.info("firebase : removeUser - getDoc");
    await deleteDoc(docRef)
      .catch((error) => {
        console.log("Impossible de supprimer le document", error);
        return false;
      });
  };

  updateUser = async (uid, obj) => {
    const docRef = doc(this.db, USERS, uid);
    console.info("firebase : updateUser - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return await this.getUser(uid);
  };

  mergeUserLicencie = async (user, uidLicencie) => {
    //on garde en mémoire le licencié
    const licencie = await this.getLicencie(uidLicencie);
    //on le supprime
    await this.removeLicencie(uidLicencie);
    //on créé le licencié en reprenant les bonnes infos
    await this.addLicencie({
      uid: user.uid,
      email: user.email,
      //phoneNumber: user.phoneNumber,
      displayName:
        licencie.displayName !== "" ? licencie.displayName : user.displayName,
      firstName: licencie.firstName,
      lastName: licencie.lastName,
      genderMale: licencie.genderMale,
      description: licencie.description,
      photoURL: user.photoURL,
      photoURLCustom: licencie.photoURLCustom,
      licenceNumber: licencie.licenceNumber,
      lastLoginAt: user.lastLoginAt,
      simpleLevel: user.simpleLevel,
      doubleLevel: user.doubleLevel,
      mixteLevel: user.mixteLevel,
      lastModifiedSynchro: user.lastModifiedSynchro,
      "porte-feuille": 0,
      keyPass: false
    });
  };

  //Profil
  deleteCompte = async (user, auth) => {
    let success = false;
    success &= await auth
      .deleteCurrentUser()
      .then(() => {
        //console.log("Utilisateur supprimé niveau auth");
        return true;
      })
      .catch((error) => {
        console.error("Utilisateur non supprimé niveau auth", error);
        return false;
      });

    success &= await auth
      .logout()
      .then(() => {
        //console.log("Utilisateur déconnecté");
        return true;
      })
      .catch((error) => {
        console.error("Impossible de déconnecter l'utilisateur", error);
        return false;
      });

    if (this.isLicencie) {
      if (user.photoURLCustom) {
        success &= await this.deletePhotoURLCustom(user)
          .then(() => {
            //console.log("Image de profil supprimé");
            return true;
          })
          .catch((error) => {
            //console.log("Impossible de supprimer l'image de profil", error);
            return false;
          });
      }
      if (!this.isMemberClub) {
        success &= await this.removeLicencie(user.uid)
          .then((result) => {
            console.log(
              result
                ? "Compte supprimé dans les licencié"
                : "L'utilisateur n'était pas un licencie"
            );
            return true;
          })
          .catch((error) => {
            console.error("Problème pour supprimer le licencie de la base", error);
            return false;
          });
      } else {
        success &= await this.updateLicencie(user.uid, { removed: true })
          .then((result) => {
            console.log(
              result
                ? "Compte supprimé dans les licencié"
                : "L'utilisateur n'était pas un licencié"
            );
            return true;
          })
          .catch((error) => {
            console.error("Problème pour supprimer le licencié du club", error);
            return false;
          });
      }

    } else {
      success &= await this.removeUser(user.uid)
        .then((result) => {
          console.log(
            result
              ? "Compte supprimé dans les users"
              : "L'utilisateur n'était pas un user"
          );
          return true;
        })
        .catch((error) => {
          console.error("Problème pour supprimer le user de la base", error);
          return false;
        });
      /*await this.updateUser(user.uid, { removed: true })
        .then((result) => {
          console.log(
            result
              ? "Compte supprimé dans les users"
              : "L'utilisateur n'était pas un user"
          );
        })
        .catch((error) => {
          console.error("Problème pour supprimer le user de la base", error);
          return false;
        });*/
    }

    if (this.isPresident)
      success &= await this.setPresident(null).then(() => {
        console.log("Compte du président supprimé");
        return true;
      }
      );
    if (this.isVicePresidentd)
      success &= await this.setVicePresident(null).then(() => {
        console.log("Compte du vice président supprimé");
        return true;
      }
      );
    if (this.isTresorier)
      success &= await this.setTresorier(null).then(() => {
        console.log("Compte du trésorier supprimé");
        return true;
      }
      );
    if (this.isSecretaire)
      success &= await this.setSecretaire(null).then(() => {
        console.log("Compte du secrétaire supprimé");
        return true;
      }
      );

    if (this.isMemberBureau) {
      success &= await this.removeMembreBureau(user.uid).then(() => {
        console.log("Membre du bureau supprimé");
        return true;
      });
    }

    return success;
  };

  deletePhotoURLCustom = async (licencie) => {
    //console.log("db : deletePhotoURLCustom");
    const storageRef = ref(this.storage, this.pathPhotoURL + licencie.uid);
    await deleteObject(storageRef)
      .then(async () => {
        await this.updateLicencie(licencie.uid, { photoURLCustom: null });
      })
      .catch((error) => {
        console.error("Suppression image impossible : ", error);
      });
  };

  updatePhotoURLCustom = async (licencie, file) => {
    const storageRef = ref(this.storage, this.pathPhotoURL + licencie.uid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then(async (photoURL) => {
            await this.updateLicencie(licencie.uid, {
              photoURLCustom: photoURL,
            });
            return photoURL;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };

  //MISC
  updateLastModifiedSynchro = async (lastModifiedSynchro) => {
    await updateDoc(this.badlevierRef, { lastModifiedSynchro });
  };

  //CRENEAUX
  getCreneaux = async () => {
    const retour = [];
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX));
    const querySnap = await getDocs(q2);
    console.info("firebase : getCreneaux - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour;
  }
  getCreneau = async (creneauUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX), where("uid", "==", creneauUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getCreneau - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addCreneau = async (obj) => {
    const uid = "auto-generated" + Date.now();
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX, uid);
    const docSnap = await getDoc(docRef);
    console.info("firebase : addCreneau - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addCreneau");
      const newCreneau = {
        uid: uid,
        type: obj["type"],
        jour: obj["jour"],
        heureDebut: obj["heureDebut"],
        heureFin: obj["heureFin"],
        lieu: obj["lieu"],
        encadrants: []
      };
      await setDoc(docRef, newCreneau);
      return true;
    }
    return false;
  };

  updateCreneau = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX, uid);
    console.info("firebase : updateCreneau - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  removeCreneau = async (uid) => {
    const creneau = await this.getCreneau(uid);
    if (creneau) {
      const docRef = doc(
        this.db,
        CLUBS + "/" + BADLEVIER + "/" + CRENEAUX,
        uid
      );
      console.info("firebase : removeCreneau - getDoc");
      await deleteDoc(docRef)
        .then(() => {
          return true;
        })
        .catch((error) => {
          console.log("Impossible de supprimer le créneau", error);
          return false;
        });
    }
    return false;
  };

  //ENTRAINEMENTS
  getTrainings = async (creneauUid) => {
    const retour = [];
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX + "/" + creneauUid + "/" + ENTRAINEMENTS));
    const querySnap = await getDocs(q);
    console.info("firebase : getTrainings - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour;
  }
  getTraining = async (creneauUid, trainingUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + CRENEAUX + "/" + creneauUid + "/" + ENTRAINEMENTS), where("uid", "==", trainingUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getTraining - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addTraining = async (creneauUid, obj) => {
    const uid = "auto-generated" + Date.now();
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      uid
    );
    const docSnap = await getDoc(docRef);
    console.info("firebase : addTraining - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addTraining");
      const newTraining = {
        uid: uid,
        creneauUid: obj["creneauUid"],
        date: obj["date"],
        lieu: obj["lieu"],
        participants: obj["participants"],
        encadrants: obj["encadrants"],
        description: obj["description"],
        canceled: obj["canceled"],
      };
      await setDoc(docRef, newTraining);
      return true;
    }
    return false;
  };

  updateTraining = async (creneauUid, uid, obj) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      uid
    );
    console.info("firebase : updateTraining - getDoc");

    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  removeTraining = async (creneauUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      uid
    );
    console.info("firebase : removeTraining - getDoc");
    await deleteDoc(docRef)
      .then(() => {
        return true;
      })
      .catch((error) => {
        console.log("Impossible de supprimer l'entraînement", error);
        return false;
      });
  };



  addParticipant = async (creneauUid, trainingUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      trainingUid
    );
    console.info("firebase : addParticipant - getDoc");
    const training = await this.getTraining(creneauUid, trainingUid);
    if (!training[PARTICIPANTS].includes(uid)) {
      training[PARTICIPANTS] = [...training[PARTICIPANTS], uid];
      await updateDoc(docRef, { participants: training[PARTICIPANTS] });
      return true;
    }
    return false;
  };

  removeParticipant = async (creneauUid, trainingUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      trainingUid
    );
    console.info("firebase : removeParticipant - getDoc");
    const training = await this.getTraining(creneauUid, trainingUid);
    const indOf = training[PARTICIPANTS].indexOf(uid);
    if (indOf > -1) {
      training[PARTICIPANTS] = training[PARTICIPANTS].filter(
        (uidP) => uidP !== uid
      );
      await updateDoc(docRef, { participants: training[PARTICIPANTS] });
      return true;
    }
    return false;
  };

  addEncadrant = async (creneauUid, trainingUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      trainingUid
    );
    console.info("firebase : addEncadrant - getDoc");
    const training = await this.getTraining(creneauUid, trainingUid);
    if (!training[ENCADRANTS].includes(uid)) {
      training[ENCADRANTS] = [...training[ENCADRANTS], uid];
      await updateDoc(docRef, { encadrants: training[ENCADRANTS] });
      return true;
    }
    return false;
  };

  removeEncadrant = async (creneauUid, trainingUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid +
      "/" +
      ENTRAINEMENTS,
      trainingUid
    );
    console.info("firebase : removeEncadrant - getDoc");
    const training = await this.getTraining(creneauUid, trainingUid);
    const indOf = training[ENCADRANTS].indexOf(uid);
    if (indOf > -1) {
      training[ENCADRANTS] = training[ENCADRANTS].filter(
        (uidP) => uidP !== uid
      );
      await updateDoc(docRef, { encadrants: training[ENCADRANTS] });
      return true;
    }
    return false;
  };

  addEncadrantCreneau = async (creneauUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid
    );
    console.info("firebase : addEncadrantCreneau - getDoc");
    const creneau = await this.getCreneau(creneauUid);
    if (!creneau[ENCADRANTS].includes(uid)) {
      creneau[ENCADRANTS] = [...creneau[ENCADRANTS], uid];
      await updateDoc(docRef, { encadrants: creneau[ENCADRANTS] });
      return true;
    }
    return false;
  };

  removeEncadrantCreneau = async (creneauUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      CRENEAUX +
      "/" +
      creneauUid
    );
    console.info("firebase : removeEncadrantCreneau - getDoc");
    const creneau = await this.getCreneau(creneauUid);
    const indOf = creneau[ENCADRANTS].indexOf(uid);
    if (indOf > -1) {
      creneau[ENCADRANTS] = creneau[ENCADRANTS].filter(
        (uidP) => uidP !== uid
      );
      await updateDoc(docRef, { encadrants: creneau[ENCADRANTS] });
      return true;
    }
    return false;
  };

  //EQUIPES

  getEquipes = async () => {
    const retour = [];
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES));
    const querySnap = await getDocs(q);
    console.info("firebase : getEquipes - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour;
  }
  getEquipe = async (equipeUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES), where("uid", "==", equipeUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getEquipe - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addEquipe = async (obj) => {
    const uid = "auto-generated" + Date.now();
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES, uid);
    const docSnap = await getDoc(docRef);
    console.info("firebase : addEquipe - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addEquipe");
      const newEquipe = {
        uid: uid,
        name: obj["name"],
        level: obj["level"],
        capitaines: obj["capitaines"] ? obj["capitaines"] : [],
        joueurs: obj["joueurs"] ? obj["joueurs"] : []
      };
      await setDoc(docRef, newEquipe);
    }
    return null;
  };

  updateEquipe = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES, uid);
    console.info("firebase : updateEquipe - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  removeEquipe = async (uid) => {
    const equipe = await this.getEquipe(uid);
    if (equipe) {
      const docRef = doc(
        this.db,
        CLUBS + "/" + BADLEVIER + "/" + EQUIPES,
        uid
      );
      console.info("firebase : removeEquipe - getDoc");
      await deleteDoc(docRef)
        .then(() => {
          return true;
        })
        .catch((error) => {
          console.log("Impossible de supprimer l'équipe", error);
          return false;
        });
    }
    return false;
  };

  addCapitaine = async (equipeUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      EQUIPES,
      equipeUid
    );
    console.info("firebase : addCapitaine - getDoc");
    const equipe = await this.getEquipe(equipeUid);
    if (!equipe[CAPITAINES].includes(uid)) {
      equipe[CAPITAINES] = [...equipe[CAPITAINES], uid];
      await updateDoc(docRef, { capitaines: equipe[CAPITAINES] });
      return true;
    }
    return false;
  };

  removeCapitaine = async (equipeUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      EQUIPES,
      equipeUid
    );
    console.info("firebase : removeCapitaine - getDoc");
    const equipe = await this.getEquipe(equipeUid);
    const indOf = equipe[CAPITAINES].indexOf(uid);
    if (indOf > -1) {
      equipe[CAPITAINES] = equipe[CAPITAINES].filter(
        (uidP) => uidP !== uid
      );
      await updateDoc(docRef, { capitaines: equipe[CAPITAINES] });
      return true;
    }
    return false;
  };

  addJoueur = async (equipeUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      EQUIPES,
      equipeUid
    );
    console.info("firebase : addJoueur - getDoc");
    const equipe = await this.getEquipe(equipeUid);
    if (!equipe[JOUEURS].includes(uid)) {
      equipe[JOUEURS] = [...equipe[JOUEURS], uid];
      await updateDoc(docRef, { joueurs: equipe[JOUEURS] });
      return true;
    }
    return false;
  };

  removeJoueur = async (equipeUid, uid) => {
    const docRef = doc(
      this.db,
      CLUBS +
      "/" +
      BADLEVIER +
      "/" +
      EQUIPES,
      equipeUid
    );
    console.info("firebase : removeJoueur - getDoc");
    const equipe = await this.getEquipe(equipeUid);
    const indOf = equipe[JOUEURS].indexOf(uid);
    if (indOf > -1) {
      equipe[JOUEURS] = equipe[JOUEURS].filter(
        (uidP) => uidP !== uid
      );
      await updateDoc(docRef, { joueurs: equipe[JOUEURS] });
      return true;
    }
    return false;
  };

  getCapitaines = async (equipe) => {
    if (equipe[CAPITAINES].length === 0) return [];
    const retour = [];
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES), where("uid", "in", equipe[CAPITAINES]));
    const querySnap = await getDocs(q2);
    console.info("firebase : getCapitaines - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour;
  }

  getJoueurs = async (equipe) => {
    if (equipe[JOUEURS].length === 0) return [];
    const retour = [];
    const q2 = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EQUIPES), where("uid", "in", equipe[JOUEURS]));
    const querySnap = await getDocs(q2);
    console.info("firebase : getJoueurs - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour;
  }


  //Boutique
  getArticles = async () => {
    const retour = [];
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + ARTICLES));
    const querySnap = await getDocs(q);
    console.info("firebase : getArticles - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
    );
  }
  getArticle = async (articleUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + ARTICLES), where("uid", "==", articleUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getArticle - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addArticle = async (article) => {
    const docRef = doc(
      this.db,
      CLUBS + "/" + BADLEVIER + "/" + ARTICLES,
      article.uid
    );
    console.info("firebase : addArticle - doc");
    const docSnap = await getDoc(docRef);
    console.info("firebase : getArticle - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addArticle");
      await setDoc(docRef, article);
      return true;
    }
    return false;
  };

  removeArticle = async (uid) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + ARTICLES, uid);
    console.info("firebase : removeArticle - getDoc");
    await deleteDoc(docRef)
      .catch((error) => {
        console.log("Impossible de supprimer le document", error);
        return false;
      });
  };

  updateArticle = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + ARTICLES, uid);
    console.info("firebase : updateArticle - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  deletePhotoUrlArticle = async (article) => {
    console.log("db : deletePhotoURLCustom");
    const storageRef = ref(this.storage, this.pathPhotoURLArticle + article.uid);
    await deleteObject(storageRef)
      .then(async () => {
        await this.updateArticle(article.uid, { photoUrl: null });
      })
      .catch((error) => {
        console.error("Suppression image impossible : ", error);
      });
  };
  updatePhotoUrlArticle = async (articleUid, file) => {
    const storageRef = ref(this.storage, this.pathPhotoURLArticle + articleUid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then(async (photoURL) => {
            await this.updateArticle(articleUid, {
              photoUrl: photoURL,
            });
            return photoURL;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };

  addPhotoUrlArticle = async (articleUid, file) => {
    const storageRef = ref(this.storage, this.pathPhotoURLArticle + articleUid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then((photoURL) => {
            return photoURL;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };

  //Events
  getEvents = async () => {
    const retour = [];
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EVENTS));
    const querySnap = await getDocs(q);
    console.info("firebase : getEvents - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
    );
  }
  getEvent = async (eventUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + EVENTS), where("uid", "==", eventUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getEvent - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addEvent = async (event) => {
    const docRef = doc(
      this.db,
      CLUBS + "/" + BADLEVIER + "/" + EVENTS,
      event.uid
    );
    console.info("firebase : addArticle - doc");
    const docSnap = await getDoc(docRef);
    console.info("firebase : getArticle - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addArticle");
      await setDoc(docRef, event);
      return true;
    }
    return false;
  };

  removeEvent = async (uid) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + EVENTS, uid);
    console.info("firebase : removeEvent - getDoc");
    await deleteDoc(docRef)
      .catch((error) => {
        console.log("Impossible de supprimer le document", error);
        return false;
      });
  };

  updateEvent = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + EVENTS, uid);
    console.info("firebase : updateEvent - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  deletePhotoUrlEvent = async (eventItem) => {
    console.log("db : deletePhotoURLCustom");
    const storageRef = ref(this.storage, this.pathPhotoURLEvent + eventItem.uid);
    await deleteObject(storageRef)
      .then(async () => {
        await this.updateEvent(eventItem.uid, { photoUrl: null });
      })
      .catch((error) => {
        console.error("Suppression image impossible : ", error);
      });
  };
  updatePhotoURLEvent = async (eventUid, file) => {
    const storageRef = ref(this.storage, this.pathPhotoURLEvent + eventUid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then(async (photoURL) => {
            await this.updateEvent(eventUid, {
              photoUrl: photoURL,
            });
            return photoURL;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };

  addPhotoUrlEvent = async (eventUid, file) => {
    const storageRef = ref(this.storage, this.pathPhotoURLEvent + eventUid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then((photoURL) => {
            return photoURL;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };

  //Documents
  getDocuments = async () => {
    const retour = [];
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + DOCUMENTS));
    const querySnap = await getDocs(q);
    console.info("firebase : getDocuments - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      querySnap.docs.forEach(doc => {
        retour.push(doc.data());
      })
    }
    return retour.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
    );
  }
  getDocument = async (documentUid) => {
    const q = query(collection(this.db, CLUBS + "/" + BADLEVIER + "/" + DOCUMENTS), where("uid", "==", documentUid), limit(1));
    const querySnap = await getDocs(q);
    console.info("firebase : getDocument - getDocs => nb : " + querySnap.docs.length);
    if (!querySnap.empty) {
      return querySnap.docs[0].data();
    }
    return null;
  }

  addDocument = async (event) => {
    const docRef = doc(
      this.db,
      CLUBS + "/" + BADLEVIER + "/" + DOCUMENTS,
      event.uid
    );
    console.info("firebase : addDocument - doc");
    const docSnap = await getDoc(docRef);
    console.info("firebase : getDocument - getDoc");
    if (!docSnap.exists()) {
      console.log("db : addDocument");
      await setDoc(docRef, event);
      return true;
    }
    return false;
  };

  removeDocument = async (uid) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + DOCUMENTS, uid);
    console.info("firebase : removeDocument - getDoc");
    await deleteDoc(docRef)
      .catch((error) => {
        console.log("Impossible de supprimer le document", error);
        return false;
      });
  };

  updateDocument = async (uid, obj) => {
    const docRef = doc(this.db, CLUBS + "/" + BADLEVIER + "/" + DOCUMENTS, uid);
    console.info("firebase : updateDocument - getDoc");
    for (const key in obj) {
      if (obj[key] === undefined) obj[key] = null;
    }
    await updateDoc(docRef, obj);
    return true;
  };

  deleteDocumentStorage = async (documentItem) => {
    console.log("db : deleteDocumentStorage");
    const storageRef = ref(this.storage, this.pathDocumentUrl + documentItem.uid);
    await deleteObject(storageRef)
      .then(async () => {
        await this.updateDocument(documentItem.uid, { photoUrl: null, fileName: null });
      })
      .catch((error) => {
        console.error("Suppression document impossible : ", error);
      });
  };

  addDocumentStorage = async (documentUid, file) => {
    const storageRef = ref(this.storage, this.pathDocumentUrl + documentUid);
    return await uploadBytes(storageRef, file)
      .then(async (snapshot) => {
        return await getDownloadURL(storageRef)
          .then((docUrl) => {
            return docUrl;
          })
          .catch((error) => {
            return error;
          });
      })
      .catch((error) => {
        return error;
      });
  };
  documentDownload = async (doc) => {
    const storageRef = ref(this.storage, this.pathDocumentUrl + doc.uid);
    await getDownloadURL(storageRef)
      .then(async (url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
          console.log("blob", blob);
          const blobURL = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobURL;
          a.download = doc.fileName; // Remplacez par le nom de fichier souhaité
          a.click();
          URL.revokeObjectURL(blobURL);
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        console.error("Download impossible : ", error);
      });
  };
}


export default Database;
